import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "o-container -container-sm" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "o-title-hero u-mb-md u-text-outline-color-2-light" }, [
  /*#__PURE__*/_createTextVNode(" Calendrier "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("des activités ")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "u-bg-color-white u-py-lg o-calendar__wrap" }
const _hoisted_4 = { class: "o-container" }
const _hoisted_5 = { class: "o-calendar" }
const _hoisted_6 = { class: "o-calendar__header u-mb-md" }
const _hoisted_7 = { class: "o-title-3 o-calendar__month" }
const _hoisted_8 = { class: "o-calendar__month__label" }
const _hoisted_9 = { class: "o-calendar__filters c-overlay-mobile" }
const _hoisted_10 = { class: "c-overlay-mobile__header" }
const _hoisted_11 = { class: "o-switch__listing" }
const _hoisted_12 = { class: "o-switch__label" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "o-calendar__legend" }, null, -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Activer le filtre ", -1 /* HOISTED */)
const _hoisted_15 = { class: "o-switch__toggle" }
const _hoisted_16 = ["aria-label"]
const _hoisted_17 = ["value"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "o-switch__slider" }, null, -1 /* HOISTED */)
const _hoisted_19 = { class: "o-switch__wrap" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "o-switch__label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Activer le filtre "),
  /*#__PURE__*/_createTextVNode("En présence ")
], -1 /* HOISTED */)
const _hoisted_21 = { class: "o-switch__toggle" }
const _hoisted_22 = {
  class: "o-switch",
  "aria-label": "Activer le filtre - En présence"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "o-switch__slider" }, null, -1 /* HOISTED */)
const _hoisted_24 = { class: "o-switch__wrap" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "o-switch__label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Activer le filtre "),
  /*#__PURE__*/_createTextVNode("En ligne ")
], -1 /* HOISTED */)
const _hoisted_26 = { class: "o-switch__toggle" }
const _hoisted_27 = {
  class: "o-switch",
  "aria-label": "Activer le filtre - En ligne"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "o-switch__slider" }, null, -1 /* HOISTED */)
const _hoisted_29 = { class: "c-overlay-mobile__trigger__wrap" }
const _hoisted_30 = { class: "o-calendar__main" }
const _hoisted_31 = { class: "o-calendar__layout" }
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"o-calendar__week\"><div class=\"o-calendar__week__item\"><div class=\"o-title-4 o-calendar__week__label\">Di</div></div><div class=\"o-calendar__week__item\"><div class=\"o-title-4 o-calendar__week__label\">Lu</div></div><div class=\"o-calendar__week__item\"><div class=\"o-title-4 o-calendar__week__label\">Ma</div></div><div class=\"o-calendar__week__item\"><div class=\"o-title-4 o-calendar__week__label\">Me</div></div><div class=\"o-calendar__week__item\"><div class=\"o-title-4 o-calendar__week__label\">Je</div></div><div class=\"o-calendar__week__item\"><div class=\"o-title-4 o-calendar__week__label\">Ve</div></div><div class=\"o-calendar__week__item\"><div class=\"o-title-4 o-calendar__week__label\">Sa</div></div></div>", 1)
const _hoisted_33 = { class: "o-calendar__days" }
const _hoisted_34 = { class: "o-calendar__days__item" }
const _hoisted_35 = {
  key: 0,
  class: "o-calendar__days__item"
}
const _hoisted_36 = { class: "o-title-5 o-calendar__days__label" }
const _hoisted_37 = { class: "o-calendar__events" }
const _hoisted_38 = ["href"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "o-calendar__legend" }, null, -1 /* HOISTED */)
const _hoisted_40 = { class: "o-calendar__events__title" }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = { class: "o-tooltip" }
const _hoisted_43 = { class: "o-tooltip__content" }
const _hoisted_44 = ["href"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "o-calendar__legend" }, null, -1 /* HOISTED */)
const _hoisted_46 = { class: "o-calendar__events__title" }
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = { class: "o-calendar__days__item" }
const _hoisted_49 = {
  key: 0,
  class: "o-calendar__empty"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", { class: "o-title-4" }, " Aucune activité pour ce mois-ci. ", -1 /* HOISTED */)
const _hoisted_51 = [
  _hoisted_50
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Image = _resolveComponent("Image")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "o-calendar__month__action -month-prev",
                "aria-label": "Mois précédent",
                type: "button",
                onClick: _cache[0] || (_cache[0] = $event => ($options.fetchPreviousMonth()))
              }, [
                _createVNode(_component_Image, {
                  id: "arrow-right",
                  class: "-ico-arrow-left"
                })
              ]),
              _createElementVNode("span", _hoisted_8, _toDisplayString($options.monthStringUpper) + " " + _toDisplayString($options.year), 1 /* TEXT */),
              _createElementVNode("button", {
                class: "o-calendar__month__action -month-next",
                "aria-label": "Mois suivant",
                type: "button",
                onClick: _cache[1] || (_cache[1] = $event => ($options.fetchNextMonth()))
              }, [
                _createVNode(_component_Image, {
                  id: "arrow-right",
                  class: "-ico-arrow-right"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "c-overlay-mobile__close",
                  onClick: _cache[2] || (_cache[2] = $event => ($options.classToggle('html', 'has-overlay-mobile-open', '.c-overlay-mobile'))),
                  "aria-label": "Fermer le panneau pour filtrer les résultats"
                }, [
                  _createTextVNode(" Fermer "),
                  _createVNode(_component_Image, {
                    id: "close",
                    class: "-ico-close"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.event_types, (t) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["o-switch__wrap", '-filter-theme-'+t.class])
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _hoisted_14,
                      _createTextVNode(_toDisplayString(t.name), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", {
                        class: "o-switch",
                        "aria-label": 'Activer le filtre - '+t.name
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          class: "o-switch__checkbox",
                          value: t.slug,
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.selectedCategories) = $event))
                        }, null, 8 /* PROPS */, _hoisted_17), [
                          [_vModelCheckbox, $data.selectedCategories]
                        ]),
                        _hoisted_18
                      ], 8 /* PROPS */, _hoisted_16)
                    ])
                  ], 2 /* CLASS */))
                }), 256 /* UNKEYED_FRAGMENT */)),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        class: "o-switch__checkbox",
                        value: "presence",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.selectedTypeActivite) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelCheckbox, $data.selectedTypeActivite]
                      ]),
                      _hoisted_23
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("label", _hoisted_27, [
                      _withDirectives(_createElementVNode("input", {
                        class: "o-switch__checkbox",
                        value: "ligne",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.selectedTypeActivite) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelCheckbox, $data.selectedTypeActivite]
                      ]),
                      _hoisted_28
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", {
                class: "c-overlay-mobile__trigger",
                type: "button",
                onClick: _cache[6] || (_cache[6] = $event => ($options.classToggle('html', 'has-overlay-mobile-open', '.c-overlay-mobile')))
              }, [
                _createTextVNode(" Filtrez "),
                _createVNode(_component_Image, {
                  id: "filter",
                  class: "-ico-filter"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.blankDaysBefore, (day) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_34))
                }), 256 /* UNKEYED_FRAGMENT */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...Array(new Date($options.year, $options.month, 0).getDate()).keys()], (day) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    ($options.eventsOf(day + 1).length>0 || !$options.isMobile())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createTextVNode(_toDisplayString(day + 1), 1 /* TEXT */),
                            _createElementVNode("span", null, _toDisplayString($options.monthString), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.eventsOf(day + 1), (event) => {
                              return (_openBlock(), _createElementBlock("a", {
                                key: event.id,
                                href: event.link,
                                class: _normalizeClass(["o-calendar__events__item", '-filter-theme-' + $options.getCategoryClass(event)]),
                                target: "_blank"
                              }, [
                                _hoisted_39,
                                _createElementVNode("div", _hoisted_40, [
                                  (!event.hide_hour)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(event.hour.replace(/^0+/, '')) + " | ", 1 /* TEXT */)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true),
                                  _createElementVNode("span", {
                                    innerHTML: event.title
                                  }, null, 8 /* PROPS */, _hoisted_41)
                                ])
                              ], 10 /* CLASS, PROPS */, _hoisted_38))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.eventsOf(day + 1), (event) => {
                                return (_openBlock(), _createElementBlock("a", {
                                  key: event.id,
                                  href: event.link,
                                  class: _normalizeClass(["o-calendar__events__item", '-filter-theme-' + $options.getCategoryClass(event)]),
                                  target: "_blank"
                                }, [
                                  _hoisted_45,
                                  _createElementVNode("div", _hoisted_46, [
                                    (!event.hide_hour)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(event.hour.replace(/^0+/,'')) + " | ", 1 /* TEXT */)
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : _createCommentVNode("v-if", true),
                                    _createElementVNode("span", {
                                      innerHTML: event.title
                                    }, null, 8 /* PROPS */, _hoisted_47)
                                  ])
                                ], 10 /* CLASS, PROPS */, _hoisted_44))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                }), 256 /* UNKEYED_FRAGMENT */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.blankDaysAfter, (day) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_48))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]),
              (!$data.events.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_51))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}